import { Flex, Input as InputAntd, InputProps, Typography } from "antd";
import { ChangeEvent } from "react";
import styled from "styled-components";

const { Text } = Typography;

interface Props extends Omit<InputProps, "style"> {
  colorText?: string;
  width?: string;
  bgColor?: string;
  border?: string;
  height?: string;
  fontSize?: string | number;
  errors?: string;
  title?: string;
  name?: string;
  type?: "text" | "password";
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const Input: React.FC<Props> = ({
  colorText = "#2A4365",
  width = "100%",
  bgColor = "#EDF2F7",
  border = "none",
  height = "60px",
  fontSize = "16px",
  prefix,
  errors,
  title,
  name,
  onChange,
  type,
  ...rest
}) => {
  return (
    <WrapperInput>
      <Flex gap={"10px"}>
        {prefix ? prefix : null}
        <Title>{title}</Title>
      </Flex>
      <StyledInput
        as={type === "password" ? InputAntd.Password : InputAntd}
        $colorText={colorText}
        $width={width}
        $bgColor={bgColor}
        $border={border}
        $height={height}
        $fontSize={fontSize}
        onChange={onChange}
        name={name}
        status={errors ? "error" : ""}
        {...rest}
      />
      {errors ? <TextError>{errors}</TextError> : null}
    </WrapperInput>
  );
};

export default Input;

const StyledInput = styled(InputAntd)<{
  $colorText: string;
  $width: string;
  $bgColor: string;
  $border: string;
  $height: string;
  $fontSize: string | number;
}>`
  height: ${(props) => props.$height};
  width: ${(props) => props.$width};
  color: ${(props) => props.$colorText} !important;
  background-color: ${(props) => props.$bgColor} !important;
  border: ${(props) => props.$border};
  font-size: ${(props) => props.$fontSize};
  border-radius: 5px;
`;

const WrapperInput = styled(Flex)`
  position: relative;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

const Title = styled(Text)`
  font-size: 20px;
`;

const TextError = styled(Text)`
  font-size: 16px;
  position: absolute;
  bottom: -30px;
  color: #ff4d4f;
`;
